let ms_events = [];

export function ms_subscribe(eventName, handler) {
  // initialize handlers
  if (!ms_events[eventName]) ms_events[eventName] = [];

  // add handler
  let handlers = ms_events[eventName];
  if (handlers.every(h => h !== handler)) {
    handlers.push(handler);
  }
}

export function ms_unsubscribe(eventName, handler) {
  // initialize handlers
  if (ms_events[eventName]) {
    // filter out handler
    ms_events[eventName] = ms_events[eventName].filter(h => h !== handler);
  }
}

export function ms_subcount(eventName) {
  return (ms_events[eventName] || []).length;
}

export async function ms_dispatch(eventName, payload, a1, a2, a3, a4, a5) {
  if (ms_events[eventName]) {
    // from where it is called
    // $file = debug_backtrace(1);
    // var_dump($file); exit;
    let handlers = ms_events[eventName];
    for (let h in handlers) {
      let handler = handlers[h];
      await handler(payload, a1, a2, a3, a4, a5);
    }
  }
}
